import styled, { createGlobalStyle } from "styled-components";
// import "./font.css";
import "./fonts/font.css";

export const GlobalStyles = createGlobalStyle`


*,
*::before,
*::after{
    box-sizing: border-box;
    
}
:root {
  --clr-darkgray: #202020;

   --clr-gray: #6d6868;;
    --clr-settingstopbar: #383838;
    --clr-settingsbg: #282c28;
    --clr-settingsfontgray: #575b57;
    


  

    
    --fs-h1: 3rem;
    --fss-h2: 2.25rem;
    --fs-h3: 1.25rem;
    --fs-body: 1rem;
    --bs: 0.25em 0.25em 0.75em rgba(0,0,0,.25),
          0.125em 0.125em 0.25em rgba(0,0,0,.15);

}

img {
  user-select: none;
}

a {
  text-decoration: none;
  cursor: pointer;

}

a:hover{
  cursor: pointer;

}

html{

  // only working for chrome
  @media all and (max-width: 767px) and (orientation: landscape) {
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg); 
        transform-origin: left top;
        -webkit-transform-origin: left top; 
        width: 100vh;
        height: 100vw;
        overflow-x: hidden;
        position: absolute;
        top: 100%;
        left: 0;


  
  }


}






#root{

 
}

input[type='text'],
input[type='number'],
input[type='password']{
  font-size: 20px;
}


.hi{
  font-size: 4em;
  color: pink;
z-index: 1000000;
}

button {
  font-family: 'PhilipsScreenFont';
  cursor: pointer;
  font-size: .8rem;

}
button:hover{
  cursor: pointer;

}



body {

  margin: 0;
    color: #caceca;

  
  font-family: 'PhilipsScreenFont';

  font-size: .8rem;

   @media screen and (max-width: 767px) {

  }

  
  }




  
.config{
  position: relative
}

.noselect{
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */

/* cursor: pointer; */
                                }



img {
    display: block;
    width: 100%;
     height: 100%;
}

`;

export const AppBg = styled.div`
  background-size: contain;

  height: 100%;
  width: 100%;
  position: fixed;

  display: grid;
  justify-content: center;
  /* @media screen and (max-width: 500px) {
    justify-content: ${({ native }) => (native ? "left" : "center")};
  } */
`;

export const AppBox = styled.div`
  position: relative;
  margin: auto;
  max-width: 400px;
`;

export const DeviceImage = styled.img`
  max-width: 400px;
`;

export const ScreenTest = styled.div`
  position: absolute;
  top: 14.5%;
  left: 18.7%;
  width: 62%;
  max-width: 310px;
  height: 47.5%;
  /* border: 1px solid red; */
`;

export const ContentBox = styled.div`
  height: 71%;
  background-color: black;
  /* background-color: red; */
`;

export const Grid = styled.div`
  display: grid;
  height: 100%;
  background: black;
  row-gap: 0.7em;

  & img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    padding: 0 1em;
  }
`;

export const LockBox = styled.div`
  position: absolute;
  top: 0;
  height: 46%;
  width: 100%;
  z-index: 10000;
  opacity: 0.5;
`;

export const LockBoxLight = styled.div`
  position: absolute;
  top: 29%;
  height: 15%;
  width: 100%;
  z-index: 10000;
  opacity: 0;
`;

export const Dot = styled.div`
  position: fixed;
  width: 5px;
  height: 5px;
  background-color: orange;
  border-radius: 50%;
`;
